<script>
import Question from '@/components/Question'
import { previewImage } from '@/assets/js/preview-image'

export default {
  name: 'VoteAnswerQuestion',
  extends: Question,
  data() {
    return {
      showPopup: false
    }
  },
  methods: {
    onShowContent() {
      if(!this.componentName) return
      this.showPopup = true
      this.$nextTick(() => {
        previewImage(this.$refs.popupContent)
      })
    },
    initTitle() {
      let child = this.$refs.title.childNodes[0]
      let el = child
      if (child.nodeType !== 1) {
        el = this.$refs.title
      }
      const nodes = []

      if (this.question.issue.defaultTip) {
        const span = document.createElement('span')
        span.innerText = `【${this.question.issue.defaultTip}】`
        el.appendChild(span)
      }

      if (this.hasAnswerScore) {
        const span = document.createElement('span')
        span.innerHTML = `<span>${this.totalScore} 分</span>`
        span.className = 'text-theme-black-450 px-2 leading-22 rounded-small ml-2'
        el.appendChild(span)
      }
      const title = this.$refs.title
      previewImage(title)
      let note = this.$refs.note
      if (note) {
        this.isOverFlowNote = note.clientHeight < note.scrollHeight
      } else {
        this.isOverFlowNote = false
      }
    }
  }
}
</script>

<template>
  <div class="question-item bg-white box-border px-4 relative" @click="onShowContent">
    <!-- unknown-wrap 只有在量表生效 -->
    <div>
      <div ref="title" class="q-title leading-base break-words" v-html="title"></div>
    </div>
    <div class="q-desc-wrap" :class="[isOverFlowNote ? 'pb-8' : '']">
      <div ref="note" class="q-desc text-medium break-words leading-base pl-5 mt-1" :class="getNoteClass"
           v-if="showNote">
        <div v-html="question.note"></div>
      </div>
      <div v-if="isOverFlowNote" class="operate-btn" @click="isOpenNote = !isOpenNote">
        <span class="text-theme">{{ isOpenNote ? '收起' : '展开' }}</span>
        <van-icon :name="isOpenNote ? 'arrow-up' : 'arrow-down'"></van-icon>
      </div>
    </div>
    <!--    <div class="q-content mt-2" ref="qContent">-->
    <!--      <component :is="componentName" :question="question"></component>-->
    <!--    </div>-->
    <template v-if="content.allowPhotoNum && content.allowPhotoNum > 0">
      <adapter-upload-files :content="content" />
    </template>
    <van-popup
        @click.native.stop
        v-model="showPopup"
        position="right"
        closeable
        close-icon-position="top-left"
        style="height: 100%;width: 100%;"
        :duration="0.2"
        close-icon="arrow-left"
    >
      <div class="content-wrapper" ref="popupContent">
        <component :is="componentName" :question="question"></component>
      </div>
    </van-popup>
  </div>
</template>

<style scoped lang="scss">
.content-wrapper {
  padding: 50px 20px 0;
}
</style>